import BaseService from 'services/BaseService';

//-------------------------------------------------------------------------------------------------------------------

export default class TageService
    extends BaseService {

    static async list(param) {
        return BaseService.callAPI('tag/list', param);
    }

    static async get(id) {
        return BaseService.callAPI('tag/get/' + id);
    }

    static async save(tag) {
        return BaseService.callAPI('tag/save', tag);
    }

    static async delete(id) {
        return BaseService.callAPI('tag/delete/' + id);
    }

    static listTypes() {
        return [
            'DevTask',
            'Instructor'
        ];
    }

    static getTypeFriendly(type) {
        switch (type) {
            case 'DevTask': return 'Development tasks';
            case 'Instructor': return 'Instructors';
        }
        return type;
    }
}
